import React, { useCallback, useEffect, useState } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';

export const PRIVACY_POLICY_PATH = '/privacy-policy';

function App() {
  const [currentSection, setCurrentSection] = useState('home');
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const navigate = useCallback((to: string) => {
    if (window.location.pathname !== to) {
      window.history.pushState({}, '', to);
    }
    setPath(to);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const scrollToSection = (sectionId: string) => {
    setCurrentSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (path.replace(/\/+$/, '') === PRIVACY_POLICY_PATH) {
    return <PrivacyPolicy onBack={() => navigate('/')} />;
  }

  return (
    <div className="min-h-screen bg-white">
      <Navigation currentSection={currentSection} onNavigate={scrollToSection} />

      <main>
        <section id="home">
          <Hero />
        </section>

        <section id="about">
          <About />
        </section>

        <section id="services">
          <Services />
        </section>

        <section id="contact">
          <Contact />
        </section>
      </main>

      <Footer onPrivacyPolicyClick={() => navigate(PRIVACY_POLICY_PATH)} />
    </div>
  );
}

export default App;
